import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

function Title(props) {
  return (
    
    <></>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;
